module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABX0lEQVQ4T5XSTStEURgH8P//XG9JFtyxsVDca+NDWCvKRllY+QBTZhrJyo7iCgsLCwvZsOUDWNla2OleKaOYtwhTY9zz10wNmimNszvn6dfzch6649tbsJogaSwkAxIABHRRujWWO0+3qeva2+/DQS/4IFAk8ADA4BuqS8Q9ZTcKYeaiBSb84CUWlkph+rA5+Nedrh88w3K5EKUO/g0lrhbD1P5f0PU2ZwgzC3E9H6XCesa24GgwTsMTQLH91EILdP1gGhaTACUHcaMKB6pIGAEwZ4W7JnjqJLzsnqj5GqDw2YAiYogxoGEB1ZaMnrfX/Qj0o7dClLtVg25fXH1/lQtiHdQUxN22exzwgkUDrBmDw9xNeq1tmBjb9mJoqBSlL+tt1KZqLJK5KH30r39M+EFZ4jEcnZuqOhorZ2k7LVX6QM/VW5jMt6yc6wcRAVf6GX29FMKRkAXsSiHMnDXDL+8xvZcTP9YXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-logout.png
// module id = Pgfn
// module chunks = 1 2